import { LucideCalendar } from "lucide-react";
import React from "react";

import { Stack, Heading } from "@/components/ui";

/**
 * TimelineHeader - Header component for Timeline screen
 *
 * @returns Timeline header component with title and description
 *
 */
export const TimelineHeader: React.FC = () => {
  return (
    <Stack align="center" direction="row" justify="between">
      <Stack direction="col" gap={1}>
        <Heading className="text-xl font-semibold text-white" level={2}>
          Roadmap Timeline
        </Heading>
        <p className="text-slate-300">Timeline visualization with real data and dependencies</p>
      </Stack>
      <Stack align="center" className="text-slate-300" direction="row" gap={2}>
        <LucideCalendar className="w-4 h-4" />
        <span className="text-sm">Timeline View</span>
      </Stack>
    </Stack>
  );
};
